/**
 * @fileoverview Zod schema for TenantDetailModal's "Reassign Owner" form.
 * @description Every issue message is a translation key (per this repo's i18n rule for
 * validators), translated only at the display call site in ReassignOwnerForm.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { z } from 'zod'

export const reassignOwnerFormSchema = z.object({
  toOwnerId: z.string().trim().min(1, 'sales.tenantDetail.reassign.errors.ownerRequired'),
})

export type ReassignOwnerFormValues = z.infer<typeof reassignOwnerFormSchema>
